import { patchUserProfile } from '@uplift/api';

type UpdateUserTimezoneArgs = {
  timezone: string;
  userId: string;
};

export const useUpdateUserTimezone = () => {
  return async (params: UpdateUserTimezoneArgs) => {
    const response = await patchUserProfile(params.userId, { timezone: params.timezone });

    return response.data.timezone;
  };
};
